'use client';

import { c as _c } from "react/compiler-runtime";
import { XMarkIcon } from '@heroicons/react/24/outline';
import checkThickIcon from '@public/images/check_thick.svg';
import { motion } from 'motion/react';
import Image from 'next/image';
import { useBreakpoints } from '@src/utils/breakpoints.util';
type PostWorkoutInterstitialProps = {
  headline: string;
  isHiding: boolean;
  onClose: () => void;
};
const circleExpand = {
  scale: [0, 1.25, 0.85, 1.1, 1],
  transition: {
    duration: 0.6,
    times: [0, 0.3, 0.55, 0.75, 1],
    ease: [0.22, 1, 0.36, 1] as const,
    delay: 0.6
  }
};
const checkmarkShake = {
  rotate: [-20, -12, 20, -12, 10, -5, 0],
  opacity: [0, 1, 1, 1, 1, 1, 1],
  transition: {
    duration: 0.6,
    times: [0, 0.14, 0.35, 0.5, 0.65, 0.85, 1],
    ease: 'linear' as const,
    delay: 1.35
  }
};
export function PostWorkoutInterstitial(t0) {
  const $ = _c(22);
  const {
    headline,
    isHiding,
    onClose
  } = t0;
  const {
    isDesktop
  } = useBreakpoints();
  const t1 = isHiding ? 0 : 1;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      opacity: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0
    };
    t4 = {
      opacity: 1
    };
    t5 = {
      duration: 0.5,
      ease: "easeInOut"
    };
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== isDesktop || $[6] !== onClose) {
    t6 = !isDesktop && <button aria-label="Close" className="absolute top-[18px] right-4 z-10 flex size-6 items-center justify-center" onClick={onClose} type="button"><XMarkIcon className="size-6 text-bodi-white" /></button>;
    $[5] = isDesktop;
    $[6] = onClose;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      scale: 0
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="size-full rounded-full bg-bodi-accent-bright-500" />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t10;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      transformOrigin: "44% 66%"
    };
    t10 = {
      opacity: 0,
      rotate: -20
    };
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <motion.div className="relative flex size-[48px] items-center justify-center lg:size-[56px]" initial={t7} animate={circleExpand}>{t8}<motion.div className="absolute inset-0 flex items-center justify-center" style={t9} initial={t10} animate={checkmarkShake}><Image width={37} height={37} alt="" className="size-[31.7px] lg:size-[37px]" src={checkThickIcon} /></motion.div></motion.div>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      opacity: 0,
      y: -120
    };
    t13 = {
      opacity: 1,
      y: 0
    };
    $[13] = t12;
    $[14] = t13;
  } else {
    t12 = $[13];
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      duration: 0.6,
      ease: [0.34, 1, 0.56, 1]
    };
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== headline) {
    t15 = <div className="flex w-[345px] flex-col items-center gap-[21px]">{t11}<motion.p className="text-heading-4 lg:text-heading-4 m-0 text-center font-lateral font-bold tracking-wide text-bodi-white" initial={t12} animate={t13} transition={t14}>{headline}</motion.p></div>;
    $[16] = headline;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t15 || $[19] !== t2 || $[20] !== t6) {
    t16 = <motion.div className="fixed inset-0 z-100003 flex items-center justify-center bg-bodi-black-text" animate={t2} exit={t3} initial={t4} transition={t5}>{t6}{t15}</motion.div>;
    $[18] = t15;
    $[19] = t2;
    $[20] = t6;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  return t16;
}